import {SMART_RECOMMENDATION_ACTIONS} from '../actions/smartRecommendationAction';
import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js'

export function fetchSmartRecommendationData(userId, fuelType) {
    return dispatch => {
        axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + userId + '/sponsored-reco', {
            params: {
                'measurement-type' : fuelType
            }
          }).then(
            (response) => {
              dispatch({
                type: SMART_RECOMMENDATION_ACTIONS.FETCH_SMART_RECOMMENDATION_SUCCESS,
                payload: response.data.payload
              })
            }
          )
    }  
}

